/** @format */

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Stack, Typography } from '@mui/material';

export default function ModelAbout({ open, handleClose }) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
      // sx={{
      //   fontSize: "1.4583rem!important",
      // }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            height: 72,
            width: 72
          }}
        >
          <img src="/assets/logo.png" />
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          minWidth: 300,
          mt: 2
        }}
      >
        {/* <Card sx={{ p: 6 }}> */}

        <Stack rowGap={2}>
          <Typography gutterBottom variant="h6">
            Hệ Thống Đặt Xe Trực Tuyến NHIEUXE.VN
          </Typography>

          <Stack direction="row" alignItems="baseline" columnGap={1} flexWrap="wrap">
            <Typography variant="body2" color="text.primary" fontWeight={500}>
              TRỤ SỞ:
            </Typography>
            <Typography variant="body1" color="text.primary">
              226/51 An Dương Vương, P.16, Q.8, HCM
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="baseline" columnGap={1} flexWrap="wrap">
            <Typography variant="body2" color="text.primary" fontWeight={500}>
              VPGD 1:
            </Typography>
            <Typography variant="body1" color="text.primary">
              60 Vũ Tông Phan, P.An Phú, Q.2, HCM
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="baseline" columnGap={1} flexWrap="wrap">
            <Typography variant="body2" color="text.primary" fontWeight={500}>
              Hotline 1:
            </Typography>
            <Stack direction="row" alignItems="baseline" columnGap={1}>
              <Link href="tel:091.7879.235" underline="always" variant="subtitle1">
                091.7879.235
              </Link>
              -
              <Link href="tel:09777.34334" underline="always" variant="subtitle1">
                09777.34334
              </Link>
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="baseline" columnGap={1}>
            <Typography variant="body2" color="text.primary" fontWeight={500}>
              Hotline 2 (English):
            </Typography>
            <Link href="tel:0985.70.75.81" underline="always" variant="subtitle1">
              0985.70.75.81
            </Link>
          </Stack>
          <Stack direction="row" alignItems="baseline" columnGap={1}>
            <Typography variant="body2" color="text.primary" fontWeight={500}>
              Email:
            </Typography>
            <Link href="https://nhieuxe@gmail.com" target="_blank" rel="noopener noreferrer" underline="always" variant="subtitle1">
              nhieuxe@gmail.com
            </Link>
          </Stack>
        </Stack>
        {/* </Card> */}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center'
        }}
      >
        <Button variant="outlined" color="primary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
